{
  "name": "ranvou-web",
  "version": "19.1.11",
  "scripts": {
    "ng": "ng",
    "start": "ng serve --configuration=ranvou-dev --open",
    "start-prod": "ng serve --configuration=ranvou-prod --open",
    "build-dev": "ng build --configuration=ranvou-dev",
    "build-prod": "ng build --configuration=ranvou-prod",
    "build-and-deploy-dev": "npm version patch --no-git-tag-version --no-commit-hooks; firebase use ranvou-dev; ng build --configuration=ranvou-dev; firebase deploy --only hosting:ranvou-dev -m 'deploy automatico'",
    "build-and-deploy-prod": "firebase use ranvou-prod; ng build --configuration=ranvou-prod; firebase deploy --only hosting:ranvou-prod -m 'deploy automatico'",
    "lint": "ng lint"
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "^19.2.17",
    "@angular/cdk": "^19.2.19",
    "@angular/common": "^19.2.17",
    "@angular/compiler": "^19.2.17",
    "@angular/core": "^19.2.17",
    "@angular/fire": "^18.0.1",
    "@angular/forms": "^19.2.17",
    "@angular/google-maps": "^19.2.19",
    "@angular/localize": "^19.2.17",
    "@angular/material": "^19.2.19",
    "@angular/material-moment-adapter": "^19.2.19",
    "@angular/platform-browser": "^19.2.17",
    "@angular/platform-browser-dynamic": "^19.2.17",
    "@angular/router": "^19.2.17",
    "@angular/service-worker": "^19.2.17",
    "@ckeditor/ckeditor5-angular": "^7.0.0",
    "@ckeditor/ckeditor5-build-classic": "^43.3.1",
    "@popperjs/core": "^2.11.6",
    "@types/lodash-es": "^4.17.5",
    "@types/pdfmake": "^0.2.12",
    "algoliasearch": "^4.22.0",
    "angular-split": "^20.0.0",
    "animate.css": "^4.1.1",
    "bootstrap": "^5.2.3",
    "fabric": "^6.9.0",
    "firebase": "^10.12.0",
    "jspdf": "^2.5.1",
    "leaflet": "^1.7.1",
    "mat-table-exporter": "^15.0.0",
    "moment": "^2.29.1",
    "ngx-mat-timepicker": "^16.2.0",
    "pdfmake": "^0.2.20",
    "rxjs": "^7.8.1",
    "subsink": "^1.0.2",
    "swiper": "^11.0.5",
    "tslib": "^2.3.1",
    "xlsx": "^0.18.5",
    "zone.js": "^0.15.1"
  },
  "devDependencies": {
    "@angular-devkit/architect": "^0.1902.19",
    "@angular/build": "^19.2.19",
    "@angular/cli": "^19.2.19",
    "@angular/compiler-cli": "^19.2.17",
    "@angular/language-service": "^19.2.17",
    "@types/node": "^12.20.25",
    "angular-eslint": "21.0.1",
    "eslint": "^9.39.1",
    "firebase-tools": "^9.18.0",
    "fuzzy": "^0.1.3",
    "inquirer": "^6.2.2",
    "inquirer-autocomplete-prompt": "^1.4.0",
    "ts-node": "~8.3.0",
    "typescript": "^5.8.3",
    "typescript-eslint": "8.46.4",
    "webpack-bundle-analyzer": "^4.4.2"
  }
}
